import * as THREE from 'three';
import textHelvetiker from 'three/examples/fonts/helvetiker_bold.typeface.json?url';
import { FontLoader, TextGeometry } from 'three/examples/jsm/Addons.js';

export class MenuTitleText {
  private mesh: THREE.Mesh | null = null;

  constructor(group: THREE.Group) {
    const loader = new FontLoader();
    loader.load(textHelvetiker, (font) => {
      const geometry = new TextGeometry('WHERE TO?', {
        font: font,
        size: 0.9,
        depth: 0.4,
        curveSegments: 12,
        bevelEnabled: true,
        bevelThickness: 0.05,
        bevelSize: 0.03,
        bevelOffset: 0,
        bevelSegments: 5,
      });

      geometry.center();

      const materials = [
        new THREE.MeshBasicMaterial({ color: 0xffffff }),
        new THREE.MeshBasicMaterial({ color: 0x4182b0 }),
      ];
      this.mesh = new THREE.Mesh(geometry, materials);

      this.mesh.position.set(0, 6, 0.5);
      group.add(this.mesh);
    });
  }
}
